export const PRODUCT_STATUS = {
    DISABLED: 0,
    AVAILABLE: 1,
    PENDING: 2,
}